import { Button, tokens } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import { ConfirmInfoTaskCard } from "components/molecules/ConfirmInfo/ConfirmInfoTaskCard";

const DEFAULT_PREFERRED_LANGUAGE = "English";

const ConfirmHomeInfoTask = ({
  languagePreference,
  hasAdditionalSystem,
  utilityCompany,
  homeType,
  loading,
  onOpen,
}: {
  languagePreference?: string | null;
  hasAdditionalSystem?: boolean | null;
  utilityCompany?: string | null;
  homeType?: string | null;
  loading?: boolean;
  onOpen?: () => void;
}) => {
  const rows = [
    {
      label: "Customer’s language preference",
      value: languagePreference || DEFAULT_PREFERRED_LANGUAGE,
    },
    {
      label: "Home already has solar panels",
      value: hasAdditionalSystem ? "Yes" : "No",
    },
    {
      label: "Utility company",
      value: utilityCompany || "—",
    },
    {
      label: "Home type",
      value: homeType || "—",
    },
  ];

  return (
    <ConfirmInfoTaskCard
      taskHeader="2. Confirm home info"
      subHeader="Ensure you have the correct information now before creating an offer to avoid future rework"
      taskAction={
        <Button
          onClick={onOpen}
          color="secondary"
          size="xs"
          style={{ height: "fit-content" }}
        >
          Edit
        </Button>
      }
      loading={loading}
    >
      <InfoList>
        {rows.map(({ label, value }) => (
          <InfoRow key={label}>
            <Label>{label} : </Label>
            <Value>{value}</Value>
          </InfoRow>
        ))}
      </InfoList>
    </ConfirmInfoTaskCard>
  );
};

const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
  padding-top: 32px;
`;

const InfoRow = styled.p`
  margin: 0;
  font-family: Roobert, sans-serif;
  font-size: 12px;
  line-height: 20px;
  color: ${tokens.BRAND_HERO_BLUE};
`;

const Label = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

const Value = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

export { ConfirmHomeInfoTask };
